<app-up-board *ngIf="boardPermissions.userHasEditPermissions(boardPermissions.boardUser)" [editMode]="true"></app-up-board>
<div *ngIf="!boardPermissions.userHasEditPermissions(boardPermissions.boardUser)" class="text-center">
  <h1>403 Not Authorized</h1>
  <p>Whoops! You are not authorized to view this area.</p>
</div>